// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-blog-category-jsx": () => import("./../../../src/blog/category.jsx" /* webpackChunkName: "component---src-blog-category-jsx" */),
  "component---src-blog-index-jsx": () => import("./../../../src/blog/index.jsx" /* webpackChunkName: "component---src-blog-index-jsx" */),
  "component---src-blog-post-jsx": () => import("./../../../src/blog/post.jsx" /* webpackChunkName: "component---src-blog-post-jsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-about-jsx": () => import("./../../../src/pages/about.jsx" /* webpackChunkName: "component---src-pages-about-jsx" */),
  "component---src-pages-faq-jsx": () => import("./../../../src/pages/faq.jsx" /* webpackChunkName: "component---src-pages-faq-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-privacy-jsx": () => import("./../../../src/pages/privacy.jsx" /* webpackChunkName: "component---src-pages-privacy-jsx" */)
}

